import { Project } from '@entities/clients';
import { gql, useQuery } from 'urql';

const GET_SMINEX_CLUB_PROJECTS_QUERY = gql`
  query GetSminexClubProjects {
    getSminexClubProjects {
      id
      name
      type
      active
    }
  }
`;

export interface SminexClubProjectsResponse {
  getSminexClubProjects: Project[];
}

export const useFetchSminexClubProjects = () => {
  const [{ data, fetching, error }] = useQuery<SminexClubProjectsResponse>({ query: GET_SMINEX_CLUB_PROJECTS_QUERY });

  const projects = data?.getSminexClubProjects;

  return { fetching, error, projects };
};
